module.exports = __webpack_public_path__ + "static/media/wholeSkin.adca0d22.png";